import { Edit, SimpleForm, Title, type EditProps } from "react-admin";
import { EventFormFields } from "./EventFormFields";
import { normalizeEventPayload } from "./event-payload";

const EventTitle = () => "Edit Event";

export const EventEdit = (props: EditProps) => (
  <>
    <Title title="" />
    <Edit
      {...props}
      mutationMode="pessimistic"
      title={<EventTitle />}
      redirect="/events"
      transform={normalizeEventPayload}
    >
      <SimpleForm warnWhenUnsavedChanges sx={{ maxWidth: 700 }}>
        <EventFormFields />
      </SimpleForm>
    </Edit>
  </>
);
